import { toast } from 'react-toastify'
import { SubmitFunction } from 'react-router-dom'

import { getEventDetails } from '../../../store.slice'
import { ModifyEventSchema } from '../../events/Events.schema'
import i18n from '../../../i18n'

export function onSubmitData(
  eventDetails: ReturnType<ReturnType<typeof getEventDetails>>,
  eventId: string,
  submit: SubmitFunction
) {
  try {
    const data = ModifyEventSchema.safeParse(eventDetails)

    if ('error' in data && !data.success) {
      toast.error(i18n.t("Le schéma de donnée n'est pas valide", { ns: 'common' }))
      data.error.issues.forEach(issue => {
        toast.warn(`${issue.path.toString()}: ${issue.message}`, {
          autoClose: 60000,
        })
      })
      console.error(data.error)
    }
    if ('data' in data && data.success) {
      submit(data.data, {
        method: 'POST',
        encType: 'application/json',
        action: `/admin/events/${eventId}/validation`,
      })
    }
  } catch (e) {
    console.error(e)
    toast.error(i18n.t("Le schéma de donnée n'est pas valide", { ns: 'common' }))
    toast.warn(i18n.t('Erreur innatendue', { ns: 'common' }))
  }
}
